import React, { Component } from 'react'
import './academicsDashboard.scss';
import withRouter from '../lib/withRouter';
import Authentication from '../../session';
import { connect } from 'react-redux';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import GridLayout from 'react-grid-layout';
import 'react-grid-layout/css/styles.css';
import 'react-resizable/css/styles.css';
import ReactApexChart from 'react-apexcharts';
import { Dialog } from 'primereact/dialog';
import { Toast } from 'primereact/toast';
import Service from '../../services';
import { baseUrlAdmin } from '../../store/apiConstants';
import LoadingComponent from '../loadingComponent';
import ClassetDropdown from '../../classetComponents/classetDropDown';
import BranchToClassSingleDD from '../BaseDropdownComponents/BranchToClassSingleDD';
import BranchBoardSingleDD from '../BaseDropdownComponents/BranchBoardSingleDD';
// Import your icons here
// Replace with your actual SVG icons
import { FilterIcon2, ReportsIcon, StudentIcon, TeacherCircle, QuestionMarkIcon, CalendarIcon } from '../svgIcons';
import { Skeleton } from 'primereact/skeleton'; // Add this import

class AcademicsDashboard extends Component {
    constructor(props) {
        super(props);
        this.state = {
            // Summary Cards data
            summaryData: {
                totalStudents: 0,
                teacherAvailability: 0,
                questionsAvailable: 0,
                totalWorkingDays: 0
            },

            // Star Students Table
            starStudentsData: [],

            // Progress Pie Chart
            progressChartData: {
                series: [44, 55, 13, 33],
                labels: ['Excellent', 'Good', 'Average', 'Poor']
            },
            progressChartOptions: {
                chart: {
                    type: 'pie',
                },
                colors: ['#4A3AFF', '#076EFF', '#962DFF', '#FF6B6B'],
                legend: {
                    position: 'bottom'
                }
            },
            progressExamName: '',

            // Section Performance Chart
            sectionPerformanceData: {
                categories: [],
                series: []
            },
            sectionPerformanceOptions: {
                chart: {
                    type: 'bar',
                    height: 350,
                    toolbar: { show: false }
                },
                colors: ['#962DFF', '#4A3AFF', '#E3A7FF', '#76A7FF'],
                plotOptions: {
                    bar: {
                        horizontal: false,
                        columnWidth: '55%',
                        borderRadius: 4
                    },
                },
                dataLabels: { enabled: false },
                grid: {
                    borderColor: "#E5E5EF",
                    strokeDashArray: 5
                },
                legend: {
                    show: true,
                    position: 'top',
                    horizontalAlign: 'left',
                    markers: {
                        width: 16,
                        height: 16,
                        radius: 4
                    }
                },
                xaxis: {
                    categories: []
                }
            },
            sectionFilters: {
                branchId: null,
                gradeId: null
            },
            showSectionFilterDialog: false,

            // Grade Performance Chart
            gradePerformanceData: {
                series: [],
                categories: []
            },
            gradePerformanceOptions: {
                chart: {
                    type: 'bar',
                    height: 350,
                    toolbar: { show: false }
                },
                colors: ['#962DFF', '#4A3AFF', '#E3A7FF', '#76A7FF'],
                plotOptions: {
                    bar: {
                        horizontal: false,
                        columnWidth: '55%',
                        borderRadius: 4
                    },
                },
                dataLabels: { enabled: false },
                grid: {
                    borderColor: "#E5E5EF",
                    strokeDashArray: 5
                }
            },
            showGradeFilterDialog: false,
            gradeFilters: {
                branchId: null,
                boardId: null,
            },

            // Layout and UI
            containerWidth: 0,
            layouts: [
                { i: 'star-students', x: 0, y: 0, w: 12, h: 5, minW: 6, maxW: 12, minH: 4 },
                { i: 'progress-overview', x: 0, y: 6, w: 4, h: 5, minW: 3, maxW: 12, minH: 4 },
                { i: 'section-performance', x: 4, y: 6, w: 4, h: 5, minW: 3, maxW: 12, minH: 4 },
                { i: 'grade-performance', x: 8, y: 6, w: 4, h: 5, minW: 3, maxW: 12, minH: 4 }
            ],
            isDragging: false,
            isLoading: false,
            grades: [],
        };

        this.containerRef = React.createRef();
        this.service = new Service();
    }

    componentDidMount() {
        this.updateDimensions();
        window.addEventListener('resize', this.updateDimensions);

        const defaultBranch = this.props.branchData?.[0];
        if (defaultBranch) {
            const grades = defaultBranch.classList || [];
            const defaultGrade = grades[0]?.id || '';
            this.setState({
                grades,
                sectionFilters: {
                    branchId: defaultBranch.id,
                    gradeId: defaultGrade
                }
            }, () => {
                this.fetchDashboardData();
                this.fetchStarStudentsData();
                this.fetchProgressPieChartData();
                this.fetchSectionData();
            });
        } else {
            this.fetchDashboardData();
            this.fetchStarStudentsData();
            this.fetchProgressPieChartData();
        }
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.updateDimensions);
    }

    updateDimensions = () => {
        if (this.containerRef.current) {
            this.setState({ containerWidth: this.containerRef.current.offsetWidth });
        }
    };

    fetchDashboardData = async () => {
        try {
            this.setState({ isLoading: true });

            const url = `${baseUrlAdmin}/academicsDashboard/get-summary`;
            const payload = {
                academicYear: localStorage.getItem("userAcademicYear")
            };

            const response = await this.service.post(url, payload, true);

            if (response.status && response.res.status) {
                const summaryCards = response.res.data;

                // Update state with fetched data
                this.setState({
                    summaryData: {
                        totalStudents: summaryCards?.totalStudents || 0,
                        teacherAvailability: summaryCards?.teacherAvailability || 0,
                        questionsAvailable: summaryCards?.questionsAvailable || 0,
                        totalWorkingDays: summaryCards?.totalWorkingDays || 0
                    },
                });

                this.toast.show({
                    severity: 'success',
                    summary: 'Success',
                    detail: 'Dashboard data loaded successfully',
                    life: 3000
                });
            } else {
                this.toast.show({
                    severity: 'warn',
                    summary: 'Warning',
                    detail: response.res?.message || 'Failed to load dashboard data',
                    life: 3000
                });
            }
        } catch (error) {
            console.error("API Error:", error);
            this.toast.show({
                severity: 'error',
                summary: 'Error',
                detail: error.message || 'Failed to fetch dashboard data',
                life: 3000
            });
        } finally {
            this.setState({ isLoading: false });
        }
    };

    fetchStarStudentsData = async () => {
        try {
            this.setState({ isLoading: true });

            const url = `${baseUrlAdmin}/academicsDashboard/get-star-students`;
            const payload = {
                academicYear: localStorage.getItem("userAcademicYear")
            };

            const response = await this.service.post(url, payload, true);

            if (response.status && response.res.status) {
                this.setState({ starStudentsData: response.res.data || [] });
            }
        } catch (error) {
            console.error("API Error:", error);
        } finally {
            this.setState({ isLoading: false });
        }
    };

    fetchProgressPieChartData = async () => {
        try {
            this.setState({ isLoading: true });

            const url = `${baseUrlAdmin}/academicsDashboard/get-students-percentage-pie-chart`;
            const payload = {
                academicYear: localStorage.getItem("userAcademicYear")
            };

            const response = await this.service.post(url, payload, true);

            if (response.status && response.res.status) {
                this.setState(prevState => ({
                    progressChartData: {
                        series: response.res.data.series || [],
                        labels: response.res.data.labels || []
                    },
                    progressChartOptions: {
                        ...prevState.progressChartOptions,
                        labels: response.res.data.labels || []
                    },
                    progressExamName: response.res.data.examName || ''
                }));
            }
        } catch (error) {
            console.error("API Error:", error);
        } finally {
            this.setState({ isLoading: false });
        }
    };

    fetchSectionData = async () => {
        try {
            this.setState({ isLoading: true });
            const url = `${baseUrlAdmin}/academicsDashboard/get-section-performance-summary`;
            const payload = {
                academicYear: localStorage.getItem("userAcademicYear"),
                branchId: this.state.sectionFilters.branchId,
                gradeId: this.state.sectionFilters.gradeId
            };
            const response = await this.service.post(url, payload, true);
            if (response.status && response.res.status) {
                this.setState(prevState => ({
                    sectionPerformanceData: {
                        categories: response.res.data.categories || [],
                        series: response.res.data.series || []
                    },
                    sectionPerformanceOptions: {
                        ...prevState.sectionPerformanceOptions,
                        xaxis: {
                            ...prevState.sectionPerformanceOptions.xaxis,
                            categories: response.res.data.categories || []
                        }
                    }
                }));
            }
        } catch (error) {
            console.error("API Error:", error);
        } finally {
            this.setState({ isLoading: false });
        }
    };

    // Section Performance Filter Methods
    setDropdownValues = (dropdownsData) => {
        this.setState({
            sectionFilters: {
                branchId: dropdownsData.branchId,
                gradeId: dropdownsData.classId
            }
        }, () => {
            if (!this.state.showSectionFilterDialog) {
                this.fetchSectionData();
            }
        });
    };

    toggleSectionFilter = () => {
        this.setState(prev => ({
            showSectionFilterDialog: !prev.showSectionFilterDialog
        }));
    };

    applySectionFilter = () => {
        this.setState({
            showSectionFilterDialog: false
        }, this.fetchSectionData);
    };

    // Grade Performance Filter Methods
    setGradeDropdownValues = (dropdownsData) => {
        // Add console.log to debug the incoming data
        console.log('Dropdown Data:', dropdownsData);

        this.setState({
            gradeFilters: {
                ...this.state.gradeFilters,
                branchId: dropdownsData.branchId,
                boardId: dropdownsData.boardId
            }
        }, () => {
            // Add console.log to verify state update
            console.log('Updated Filters:', this.state.gradeFilters);

            if (!this.state.showGradeFilterDialog) {
                this.fetchGradeData();
            }
        });
    };

    toggleGradeFilter = () => {
        this.setState(prev => ({
            showGradeFilterDialog: !prev.showGradeFilterDialog
        }));
    };

    applyGradeFilter = () => {
        this.setState({
            showGradeFilterDialog: false
        }, this.fetchGradeData);
    };

    fetchGradeData = async () => {
        try {
            this.setState({ isLoading: true });
            const url = `${baseUrlAdmin}/academicsDashboard/get-grade-performance-summary`;
            const payload = {
                academicYear: localStorage.getItem("userAcademicYear"),
                branchId: this.state.gradeFilters.branchId,
                boardId: this.state.gradeFilters.boardId
            };
            const response = await this.service.post(url, payload, true);
            if (response.status && response.res.status) {
                this.setState({
                    gradePerformanceData: {
                        series: response.res.data.series || [],
                        categories: response.res.data.categories || []
                    }
                });
            }
        } catch (error) {
            console.error("API Error:", error);
        } finally {
            this.setState({ isLoading: false });
        }
    };

    // Layout Methods
    onLayoutChange = (layout) => {
        this.setState({ layouts: layout });
    };

    onDragStart = (layout, oldItem, newItem, placeholder, e, element) => {
        this.setState({ isDragging: true });
        if (element) element.style.zIndex = "1000";
    };

    onDragStop = (layout, oldItem, newItem, placeholder, e, element) => {
        if (element) element.style.zIndex = "1";
        this.setState({ layouts: layout, isDragging: false });
    };

    // Render Methods
    renderSummaryCards = () => {
        const { summaryData } = this.state;

        return (
            <div className='dashboard-summary-cards'>
                <div className='cards'>
                    <div className="academics-card">
                        <div className="academics-icon-group">
                            <div className="academics-icon">
                                <StudentIcon />
                            </div>
                            <span className="academics-label">Total Students</span>
                        </div>
                        <div className="academics-divider"></div>
                        <div className="academics-amount">
                            {summaryData.totalStudents}
                        </div>
                    </div>
                    <div className="academics-card">
                        <div className="academics-icon-group">
                            <div className="academics-icon">
                                <TeacherCircle />
                            </div>
                            <span className="academics-label">Teacher Availability</span>
                        </div>
                        <div className="academics-divider"></div>
                        <div className="academics-amount">
                            {summaryData.teacherAvailability}
                        </div>
                    </div>
                </div>
                <div className='cards'>
                    <div className="academics-card">
                        <div className="academics-icon-group">
                            <div className="academics-icon">
                                <QuestionMarkIcon />
                            </div>
                            <span className="academics-label">Questions Available</span>
                        </div>
                        <div className="academics-divider"></div>
                        <div className="academics-amount">
                            {summaryData.questionsAvailable}
                        </div>
                    </div>
                    <div className="academics-card">
                        <div className="academics-icon-group">
                            <div className="academics-icon">
                                <CalendarIcon />
                            </div>
                            <span className="academics-label">Total Working Days</span>
                        </div>
                        <div className="academics-divider"></div>
                        <div className="academics-amount">
                            {summaryData.totalWorkingDays}
                        </div>
                    </div>
                </div>
            </div>
        );
    };

    renderQuickActions = () => {
        return (
            <div className='quick-actions-container'>
                <h5 className="quick-actions-header">Quick Actions</h5>
                <div className="flex justify-content-between align-items-center quick-actions">
                    <div className="text-center quick-action-item" onClick={() => this.props.navigate('/CreateTest')}>
                        <div className="academics-icon">
                            {/* Replace with appropriate icon */}
                            <svg width="24" height="24" viewBox="0 0 24 24">
                                <path d="M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM17 13H13V17H11V13H7V11H11V7H13V11H17V13Z" fill="#4A3AFF" />
                            </svg>
                        </div>
                        <p className='quickActions-title'>Create Test</p>
                    </div>
                    <div className="text-center quick-action-item" onClick={() => this.props.navigate('/QuestionBank')}>
                        <div className="academics-icon">
                            {/* Replace with appropriate icon */}
                            <svg width="24" height="24" viewBox="0 0 24 24">
                                <path d="M4 6H2V20C2 21.1 2.9 22 4 22H18V20H4V6ZM20 2H8C6.9 2 6 2.9 6 4V16C6 17.1 6.9 18 8 18H20C21.1 18 22 17.1 22 16V4C22 2.9 21.1 2 20 2ZM20 16H8V4H20V16ZM10 9H18V11H10V9ZM10 12H14V14H10V12ZM10 6H18V8H10V6Z" fill="#962DFF" />
                            </svg>
                        </div>
                        <p className='quickActions-title'>Question Bank</p>
                    </div>
                    <div className="text-center quick-action-item" onClick={() => this.props.navigate('/TestsandExams')}>
                        <div className="academics-icon">
                            {/* Replace with appropriate icon */}
                            <svg width="24" height="24" viewBox="0 0 24 24">
                                <path d="M17 12H7V14H17V12ZM19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM19 19H5V5H19V19ZM17 8H7V10H17V8Z" fill="#076EFF" />
                            </svg>
                        </div>
                        <p className='quickActions-title'>Tests & Exams</p>
                    </div>
                </div>
            </div>
        );
    };

    percentageBodyTemplate = (rowData) => {
        const percentage = parseFloat(rowData.percentage);
        return `${percentage.toFixed(2)}%`;
    };

    renderStarStudentsTable = () => {
        const examName = this.state.starStudentsData[0]?.examName || 'No exam selected';

        return (
            <div className="card h-full" style={{ background: 'transparent', boxShadow: 'none', border: 'none' }}>
                <div className="chart-header">
                    <div className="flex flex-row justify-content-between align-items-center w-100">
                        <div className="flex flex-column">
                            <h4 className="chart-Title">Star Students</h4>
                            <div className="flex flex-column">
                                <span className="academics-chart-sub-title">Top performing students</span>
                                <span className="academics-chart-sub-title" style={{ color: '#076EFF' }}>
                                    {examName}
                                </span>
                            </div>
                        </div>
                        <div className="flex align-items-center">
                            <div
                                className="select-button-wrapper prevent-grid-drag"
                                onClick={() => this.props.navigate('/starstudentsreport')}
                            >

                            </div>
                        </div>
                    </div>
                </div>
                <span className="icon-divider"></span>
                <div className="chart-body">
                    <DataTable
                        value={this.state.starStudentsData}
                        responsiveLayout="scroll"
                        scrollable
                        scrollHeight="280px"
                        style={{ width: '100%' }}
                        resizableColumns
                        columnResizeMode="fit"
                    >
                        <Column field="studentName" header="Student" />
                        <Column field="enrollmentId" header="Enroll ID" />
                        <Column field="branchName" header="Branch" />
                        <Column field="marks" header="Marks" />
                        <Column field="percentage" header="Percentage" body={this.percentageBodyTemplate} />
                    </DataTable>
                </div>
            </div>
        );
    };

    renderProgressPieChart = () => {
        const examName = this.state.progressExamName || 'No exam selected';
        return (
            <div className="card h-full" style={{ background: 'transparent', boxShadow: 'none', border: 'none' }}>
                <div className="chart-header">
                    <div className="flex flex-row justify-content-between align-items-center w-100">
                        <div className="flex flex-column">
                            <h4 className="chart-Title">Progress Overview</h4>
                            <span className="academics-chart-sub-title">Student performance distribution</span>
                            <span className="academics-chart-sub-title" style={{ color: '#076EFF' }}>
                                {examName}
                            </span>
                        </div>
                        <div className="flex align-items-center">
                            <div
                                className="select-button-wrapper prevent-grid-drag"
                                onClick={() => this.props.navigate('/progressreport')}
                            >
                            </div>
                        </div>
                    </div>
                </div>
                <span className="icon-divider"></span>
                <div className="chart-body">
                    <ReactApexChart
                        options={this.state.progressChartOptions}
                        series={this.state.progressChartData.series}
                        type="pie"
                        width="100%"
                        height="100%"
                    />
                </div>
            </div>
        );
    };

    renderSectionPerformanceChart = () => {
        const options = {
            ...this.state.sectionPerformanceOptions,
            xaxis: {
                categories: this.state.sectionPerformanceData.categories,
                axisBorder: { show: true },
                axisTicks: { show: true }
            },
            yaxis: {
                min: Math.min(
                    0,
                    ...this.state.sectionPerformanceData.series.flatMap(s => s.data)
                ),
                labels: {
                    formatter: val => val // Show negative values as-is
                }
            },
            plotOptions: {
                ...this.state.sectionPerformanceOptions.plotOptions,
                bar: {
                    ...this.state.sectionPerformanceOptions.plotOptions.bar,
                    dataLabels: {
                        position: 'top'
                    }
                }
            }
        };

        return (
            <div className="card h-full" style={{ background: 'transparent', boxShadow: 'none', border: 'none' }}>
                <div className="chart-header">
                    <div className="flex flex-row justify-content-between align-items-center w-100">
                        <div className="flex flex-column">
                            <h4 className="chart-Title">Section Performance Summary</h4>
                            <span className="academics-chart-sub-title">Comparative view of average performance by section (last 4 exams)</span>
                        </div>
                        <div className="flex align-items-center">
                            <div
                                className="select-button-wrapper prevent-grid-drag mr-2"
                                onClick={this.toggleSectionFilter}
                            >
                                <FilterIcon2 color="#333" />
                            </div>
                            <div
                                className="select-button-wrapper prevent-grid-drag"
                                onClick={() => this.props.navigate('/sectionWiseExamAnalysisReport')}
                            >
                                <ReportsIcon />
                            </div>
                        </div>
                    </div>
                    {/* Exam Legend */}
                    {this.renderSectionExamLegend()}
                </div>
                <span className="icon-divider"></span>
                <div className="chart-body">
                    <ReactApexChart
                        options={options}
                        series={this.state.sectionPerformanceData.series}
                        type="bar"
                        width="100%"
                        height="100%"
                    />
                </div>
                {/* Filter Dialog */}
                <Dialog
                    header="Filter Section Performance"
                    visible={this.state.showSectionFilterDialog}
                    style={{ width: '400px' }}
                    onHide={this.toggleSectionFilter}
                    footer={
                        <div>
                            <button
                                className="p-button p-button-secondary"
                                onClick={this.toggleSectionFilter}
                            >
                                Cancel
                            </button>
                            <button
                                className="p-button p-button-primary"
                                onClick={this.applySectionFilter}
                            >
                                Apply
                            </button>
                        </div>
                    }
                >
                    <BranchToClassSingleDD
                        setValues={this.setDropdownValues}
                    />
                </Dialog>
            </div>
        );
    };

    renderGradePerformanceChart = () => {
        const options = {
            ...this.state.gradePerformanceOptions,
            xaxis: {
                categories: this.state.gradePerformanceData.categories,
                axisBorder: { show: true },
                axisTicks: { show: true }
            },
            yaxis: {
                min: Math.min(
                    0,
                    ...this.state.gradePerformanceData.series.flatMap(s => s.data)
                ),
                labels: {
                    formatter: val => val
                }
            },
            tooltip: {
                theme: 'light',
                style: {
                    fontSize: '14px',
                    fontWeight: 600
                }
            }
        };

        return (
            <div className="card h-full" style={{ background: 'transparent', boxShadow: 'none', border: 'none' }}>
                <div className="chart-header">
                    <div className="flex flex-row justify-content-between align-items-center w-100">
                        <div className="flex flex-column">
                            <h4 className="chart-Title">Grade Performance Summary</h4>
                            <span className="academics-chart-sub-title">Comparative view of average performance by grade (last 4 exams)</span>
                        </div>
                        <div className="flex align-items-center">
                            <div
                                className="select-button-wrapper prevent-grid-drag mr-2"
                                onClick={this.toggleGradeFilter}
                            >
                                <FilterIcon2 color="#333" />
                            </div>
                        </div>
                    </div>
                    {/* Grade Legend */}
                    {this.renderGradeExamLegend()}
                </div>
                <span className="icon-divider"></span>
                <div className="chart-body">
                    <ReactApexChart
                        options={options}
                        series={this.state.gradePerformanceData.series}
                        type="bar"
                        width="100%"
                        height="100%"
                    />
                </div>
                {/* Filter Dialog */}
                <Dialog
                    header="Filter Grade Performance"
                    visible={this.state.showGradeFilterDialog}
                    style={{ width: '400px' }}
                    onHide={this.toggleGradeFilter}
                    footer={
                        <div>
                            <button
                                className="p-button p-button-secondary"
                                onClick={this.toggleGradeFilter}
                            >
                                Cancel
                            </button>
                            <button
                                className="p-button p-button-primary"
                                onClick={this.applyGradeFilter}
                            >
                                Apply
                            </button>
                        </div>
                    }
                >
                    <BranchBoardSingleDD
                        setValues={this.setGradeDropdownValues}
                    />
                </Dialog>
            </div>
        );
    };

    renderGradeExamLegend = () => {
        const colors = this.state.gradePerformanceOptions.colors || ['#962DFF'];
        const { series } = this.state.gradePerformanceData;

        if (!series || series.length === 0) return null;

        return (
            <div className="section-exam-legend" style={{ display: 'flex', gap: 24, marginBottom: 16 }}>
                {series.map((s, idx) => (
                    <div key={s.name} style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                        <span style={{
                            display: 'inline-block',
                            width: 14,
                            height: 14,
                            borderRadius: 7,
                            background: colors[idx % colors.length]
                        }} />
                        <span style={{ fontSize: 14, color: '#333', fontWeight: 500 }}>{s.name}</span>
                    </div>
                ))}
            </div>
        );
    };

    renderSectionExamLegend = () => {
        // Use the same colors as your chart
        const colors = this.state.sectionPerformanceOptions.colors || [
            '#962DFF', '#4A3AFF', '#E3A7FF', '#76A7FF'
        ];
        const { series } = this.state.sectionPerformanceData;

        if (!series || series.length === 0) return null;

        return (
            <div className="section-exam-legend" style={{ display: 'flex', gap: 24, marginBottom: 16 }}>
                {series.map((s, idx) => (
                    <div key={s.name} style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                        <span style={{
                            display: 'inline-block',
                            width: 14,
                            height: 14,
                            borderRadius: 7,
                            background: colors[idx % colors.length]
                        }} />
                        <span style={{ fontSize: 14, color: '#333', fontWeight: 500 }}>{s.name}</span>
                    </div>
                ))}
            </div>
        );
    };

    renderShimmerCards = () => (
        <div className='dashboard-summary-cards'>
            <div className='cards'>
                <div className="academics-card">
                    <div className="academics-icon-group">
                        <Skeleton shape="circle" size="2rem" />
                        <Skeleton width="8rem" height="1rem" />
                    </div>
                    <div className="academics-divider"></div>
                    <Skeleton width="6rem" height="1.5rem" />
                </div>
                <div className="academics-card">
                    <div className="academics-icon-group">
                        <Skeleton shape="circle" size="2rem" />
                        <Skeleton width="10rem" height="1rem" />
                    </div>
                    <div className="academics-divider"></div>
                    <Skeleton width="6rem" height="1.5rem" />
                </div>
            </div>
            <div className='cards'>
                <div className="academics-card">
                    <div className="academics-icon-group">
                        <Skeleton shape="circle" size="2rem" />
                        <Skeleton width="8rem" height="1rem" />
                    </div>
                    <div className="academics-divider"></div>
                    <Skeleton width="6rem" height="1.5rem" />
                </div>
                <div className="academics-card">
                    <div className="academics-icon-group">
                        <Skeleton shape="circle" size="2rem" />
                        <Skeleton width="7rem" height="1rem" />
                    </div>
                    <div className="academics-divider"></div>
                    <Skeleton width="6rem" height="1.5rem" />
                </div>
            </div>
        </div>
    );

    renderShimmerQuickActions = () => (
        <div className='quick-actions-container'>
            <Skeleton width="8rem" height="1.25rem" className="mb-3" />
            <div className="flex justify-content-between align-items-center quick-actions">
                <div className="text-center quick-action-item">
                    <Skeleton shape="circle" size="3rem" className="mb-2" />
                    <Skeleton width="6rem" height="1rem" />
                </div>
                <div className="text-center quick-action-item">
                    <Skeleton shape="circle" size="3rem" className="mb-2" />
                    <Skeleton width="5rem" height="1rem" />
                </div>
                <div className="text-center quick-action-item">
                    <Skeleton shape="circle" size="3rem" className="mb-2" />
                    <Skeleton width="6rem" height="1rem" />
                </div>
            </div>
        </div>
    );

    renderShimmerCharts = () => (
        <div style={{ width: '100%', marginTop: '19px' }}>
            <div className="flex gap-4">
                {/* Star Students Table Shimmer */}
                <div className="chart-container" style={{ minHeight: '400px', flex: 1 }}>
                    <div className='card' style={{ background: 'transparent', boxShadow: 'none', border: 'none', height: '100%' }}>
                        <div className="chart-header mb-3">
                            <Skeleton width="8rem" height="1.5rem" className="mb-2" />
                            <Skeleton width="6rem" height="1rem" />
                        </div>
                        <div className="chart-body">
                            <Skeleton width="100%" height="250px" />
                        </div>
                    </div>
                </div>
                {/* Progress Pie Chart Shimmer */}
                <div className="chart-container" style={{ width: '300px', minHeight: '400px' }}>
                    <div className='card h-full' style={{ background: 'transparent', boxShadow: 'none', border: 'none' }}>
                        <div className="chart-header mb-3">
                            <Skeleton width="6rem" height="1.5rem" className="mb-2" />
                            <Skeleton width="4rem" height="1rem" />
                        </div>
                        <div className="chart-body">
                            <Skeleton shape="circle" size="200px" />
                        </div>
                    </div>
                </div>
            </div>
            <div className="flex gap-4 mt-4">
                {/* Section Performance Chart Shimmer */}
                <div className="chart-container" style={{ width: '350px', minHeight: '400px' }}>
                    <div className='card h-full' style={{ background: 'transparent', boxShadow: 'none', border: 'none' }}>
                        <div className="chart-header mb-3">
                            <Skeleton width="7rem" height="1.5rem" className="mb-2" />
                            <Skeleton width="4rem" height="1rem" />
                        </div>
                        <div className="chart-body">
                            <Skeleton width="100%" height="200px" />
                        </div>
                    </div>
                </div>
                {/* Grade Performance Chart Shimmer */}
                <div className="chart-container" style={{ width: '350px', minHeight: '400px' }}>
                    <div className='card h-full' style={{ background: 'transparent', boxShadow: 'none', border: 'none' }}>
                        <div className="chart-header mb-3">
                            <Skeleton width="7rem" height="1.5rem" className="mb-2" />
                            <Skeleton width="4rem" height="1rem" />
                        </div>
                        <div className="chart-body">
                            <Skeleton width="100%" height="200px" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );

    render() {
        const containerStyle = {
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: '#E6E8EA',
            padding: window.innerWidth > 1090 ? "50px 0px 0px 95px" : "50px 0px 0px 15px",
            overflow: 'auto',
            transition: 'padding 0.3s',
            paddingBottom: '30px',
        };

        if (this.state.isLoading) {
            return (
                <div style={containerStyle}>
                    <div className="academics-dashboard-container">
                        <div className="dashboard-main-section">
                            {this.renderShimmerCards()}
                            {this.renderShimmerQuickActions()}
                        </div>
                        {this.renderShimmerCharts()}
                    </div>
                    <Toast ref={(el) => this.toast = el} position="bottom-right" />
                </div>
            );
        }

        return (
            <div style={containerStyle}>
                <div className="academics-dashboard-container">
                    {/* Top Section: Summary Cards and Quick Actions */}
                    <div className="dashboard-main-section">
                        {this.renderSummaryCards()}
                        {this.renderQuickActions()}
                    </div>
                    {/* Grid Layout for Charts and Table */}
                    <div ref={this.containerRef} style={{ width: '100%', marginTop: '19px' }}>
                        <GridLayout
                            className="layout"
                            layout={this.state.layouts}
                            cols={12}
                            rowHeight={80}
                            width={this.state.containerWidth}
                            margin={[15, 15]}
                            containerPadding={[0, 0]}
                            isDraggable={true}
                            isResizable={true}
                            resizeHandles={['se']}
                            onLayoutChange={this.onLayoutChange}
                            compactType="vertical"
                            preventCollision={false}
                            verticalCompact={true}
                            measureBeforeMount={true}
                            onDragStart={this.onDragStart}
                            onDragStop={this.onDragStop}
                            useCSSTransforms={true}
                            transformScale={1}
                            draggableCancel=".prevent-grid-drag"
                        >
                            {/* Star Students Table */}
                            <div key="star-students" className="chart-container">
                                {this.renderStarStudentsTable()}
                            </div>

                            {/* Progress Pie Chart */}
                            <div key="progress-overview" className="chart-container">
                                {this.renderProgressPieChart()}
                            </div>

                            {/* Section Performance Bar Chart */}
                            <div key="section-performance" className="chart-container">
                                {this.renderSectionPerformanceChart()}
                            </div>

                            {/* Grade Performance Bar Chart */}
                            <div key="grade-performance" className="chart-container">
                                {this.renderGradePerformanceChart()}
                            </div>
                        </GridLayout>
                    </div>
                </div>
                <Toast ref={(el) => this.toast = el} position="bottom-right" />
            </div>
        );
    }
}

const mapStatesToProps = (state) => ({
    branchData: state.branchDataLatest && state.branchDataLatest.data && state.branchDataLatest.data.data.filter((each => {
        if (each.level == 1) {
            return {
                key: each.id,  // Add this
                name: each.branchName,  // Add this
                ...each
            }
        }
    })) || []
});

export default connect(mapStatesToProps, {})(Authentication(withRouter(AcademicsDashboard)));